export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20editorial%20photography%20of%20diverse%20fashion%20items%20sneakers%20bags%20accessories%20arranged%20artistically%20on%20marble%20surface%20with%20warm%20morning%20light%20streaming%20through%20tall%20windows%20gentle%20beige%20and%20sand%20tones%20sophisticated%20retail%20atmosphere%20high%20end%20boutique%20aesthetic%20airy%20refined%20composition&width=1800&height=1200&seq=hero-bg-oopbuy-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet Mode Kollektion"
          title="OOPBuy Spreadsheet Produktkategorien"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-white/30 via-white/15 to-white/55"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-center gap-10 lg:gap-16 pt-20 pb-16">
        <div className="flex-1 text-center lg:text-left">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 mb-4 font-[family-name:var(--font-label)]">
            OOPBuy Spreadsheet Guide
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-6">
            Dein Ultimatives<br />
            <span className="text-primary-500">OOPBuy Spreadsheet</span><br />
            Für Den Deutschen Markt
          </h1>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed font-[family-name:var(--font-body)]">
            Entdecke das umfassendste OOPBuy Spreadsheet für Sneaker, Kleidung und Accessoires. 
            Alle Kategorien, Sicherheitstipps und Buying Guides speziell für Deutschland.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-all duration-300 font-[family-name:var(--font-label)]"
            >
              Buy It Now
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#kategorien"
              className="inline-flex items-center px-6 py-3.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors font-[family-name:var(--font-label)]"
            >
              Kategorien Entdecken
              <i className="ri-arrow-down-line ml-2"></i>
            </a>
          </div>
        </div>

        <div className="flex-1 w-full max-w-md lg:max-w-none">
          <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
            <img
              src="https://readdy.ai/api/search-image?query=Fashion%20editorial%20portrait%20style%20photography%20of%20curated%20clothing%20rack%20with%20carefully%20selected%20premium%20pieces%20against%20warm%20terracotta%20accent%20wall%20rich%20earth%20tones%20and%20natural%20fabric%20textures%20golden%20afternoon%20light%20creating%20gentle%20shadows%20luxurious%20boutique%20atmosphere%20refined%20contemporary%20aesthetic&width=800&height=1000&seq=hero-side-oopbuy-v2&orientation=portrait"
              alt="OOPBuy Spreadsheet Produkte"
              title="OOPBuy Spreadsheet Kollektion"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-foreground-400"></i>
      </div>
    </section>
  );
}